// BUILD-042 (Oct 17) - the numbered badge. Draws NOTHING for "not known yet", "not authorized" and a genuine zero; draws "!" for a failed
// check (never a 0). The text is also available to assistive technology through aria-label, and a visually hidden copy keeps the count
// readable where aria-label on a non-interactive span is ignored.
import { type BadgeView } from './attentionModel';

export function AttentionBadge({ view, className = '', testId }: { view: BadgeView; className?: string; testId?: string }) {
  if (!view.show) return null;
  const tone = view.tone === 'error' ? 'bg-amber-500 text-white' : 'bg-red-500 text-white';
  return (
    <span
      role="img"
      aria-label={view.label}
      title={view.label}
      data-testid={testId}
      data-tone={view.tone}
      className={`inline-flex items-center justify-center min-w-[1.1rem] h-[1.1rem] px-1 rounded-full text-[10px] font-bold leading-none ${tone} ${className}`}
    >
      <span aria-hidden="true">{view.text}</span>
    </span>
  );
}
